import { withPrometheusMetricsGetServerSideProps } from '@jusbrasil-web/core-next'
import {
  TesesJuridicasChatPage,
  TesesJuridicasChatPageExports,
} from '@jusbrasil-web/docview/thesis'

const { getServerSideProps: getServerSidePropsRaw } = TesesJuridicasChatPageExports
const getServerSideProps = withPrometheusMetricsGetServerSideProps(
  __filename,
  getServerSidePropsRaw
)
export { getServerSideProps }
export default TesesJuridicasChatPage
